import moment from "moment";
import React from "react";
import { IGRB2 } from "../../../../../redux/app/grb2/@types";
type OwnProps = {
	grb2Record: IGRB2;
};
type GRB2ParticipantsProps = OwnProps;
function GRB2Participants(props: GRB2ParticipantsProps) {
	const { grb2Record } = props;
	return (
		<>
			<br />
			<br />
			SUBMITTED BY: <br />
			{grb2Record.submittedBy
				? `${grb2Record.submittedBy.name} [${
						grb2Record.submittedBy.designation
				  }] - ${grb2Record.submittedBy.staffId} ${
						grb2Record.submittedBy.date
							? `on ${moment(grb2Record.submittedBy.date).toISOString()}`
							: ""
				  }`
				: "PENDING"}
			,
			<br />
			<br />
			APPROVED BY: <br />
			{grb2Record.approvedBy
				? `${grb2Record.approvedBy.name} [${
						grb2Record.approvedBy.designation
				  }] - ${grb2Record.approvedBy.staffId} ${
						grb2Record.approvedBy.date
							? `on ${moment(grb2Record.approvedBy.date).toISOString()}`
							: ""
				  }`
				: "PENDING"}
		</>
	);
}

export default GRB2Participants;
